import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, change, Field } from 'redux-form';

import { Login, loginValidation } from '../../actions/authActions';


import { Button, createTheme, Grid, TextField, ThemeProvider } from '@material-ui/core';

import logo from '../../assets/images/SentricsLogoPng.png'


const validate = (values) => {
    const errors = {};

    if (!values.user) {
        errors.user = 'Please type the user';

    }

    if (!values.password) {
        errors.password = 'Please type the password';

    }

    return errors;
};

const theme = createTheme({
    palette: {
        primary: {
            main: '#000000'
        },
    }

});

const renderTextField = ({
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
}) => (
    <ThemeProvider theme={theme}>
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
        />
    </ThemeProvider>


)




class EhubManagmentLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: '',
            password: '',
            apiError: '',
            isDisabled: true
        };

        this.props.dispatch(change('EHubManagmentLogin', 'user', ''));
        this.props.dispatch(change('EHubManagmentLogin', 'password', ''));
    }

    CheckBtnDisabled = () => {
        const updState = {
            isDisabled: this.state.isDisabled
        }

        if (this.state.user !== '' && this.state.password !== '') {
            updState.isDisabled = false;
        } else {
            updState.isDisabled = true
        }

        this.setState(updState);

    }

    componentDidMount = async () => {

        if (localStorage.getItem("token") != null) {
            await this.props.loginValidation();
            this.props.history.push("/legacyEhub");
        }
    }


    handleChange = (target) => {
        this.setState({
            ...this.state,
            [target.name]: target.value
        }, () => this.CheckBtnDisabled())
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ apiError: '' })
        const response = await this.props.Login(this.state.user, this.state.password);

        if (!response.success) {
            this.setState({ apiError: response.error })
            return;
        }

        this.props.history.push("/legacyEhub");
    }

    render() {
        return (
            <>
                <Grid item container xs={12} justifyContent='center' className='login_screen' alignItems='center' style={{ height: window.innerHeight }}>

                    <Grid item container xs={12} justifyContent='center'>
                        <Grid item container xs={12} justifyContent='center'>
                            <img
                                src={logo}
                                width='300px'
                                alt='sentrics_logo'
                            />
                        </Grid>

                        <Grid item container  xs={10} md={5} lg={4} className='login_container' justifyContent='center' >
                            <Grid item container alignItems='center' justifyContent='center'  style={{paddingBottom:'60px'}} >

                                <svg fill='#105A88' width='30px' height='30px' viewBox="0 0 576 512">
                                    <path xmlns="http://www.w3.org/2000/svg" d="M464 96H338.8l35.7-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 94.2 182.8 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L173.2 96H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h16v32h48l21.3-32h245.3l21.3 32h48v-32h16c26.5 0 48-21.5 48-48V144c.1-26.5-21.4-48-47.9-48zm-72 312s0 8-168 8c-152 0-152-8-152-8s-8 0-8-120 8-120 8-120 0-8 152-8c168 0 168 8 168 8s8 0 8 120-8 120-8 120zm72-100c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8z" />
                                </svg>
                                <span className='login_subtitle'> eHub Managment </span>
                            </Grid>
                            <form onSubmit={(e) => this.handleSubmit(e)}>
                                <Grid item container xs={12} justifyContent='center' >
                                    <ThemeProvider theme={theme}>

                                        <Field
                                            label='User'
                                            name='user'
                                            fullWidth
                                            style={{ marginBottom: '20px' }}
                                            component={renderTextField}
                                            InputLabelProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            InputProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            onChange={({ target }) => this.handleChange(target)}
                                            value={this.state.user}

                                        />

                                        <Field
                                            label='Password'
                                            name='password'
                                            fullWidth
                                            type='password'
                                            component={renderTextField}
                                            InputLabelProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            InputProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            onChange={({ target }) => this.handleChange(target)}
                                            value={this.state.password}

                                        />

                                        {
                                            this.state.apiError &&
                                            <Grid item xs={12} className='errorText'>{this.state.apiError}</Grid>
                                        }
                                    </ThemeProvider>

                                    <Grid item xs={6} lg={3} style={{paddingTop:'60px'}}>
                                        <Button
                                            className={this.state.isDisabled ? 'login_btn login_btn_disabled' : 'login_btn'}
                                            type='submit'
                                            disabled={this.state.isDisabled}>
                                            Sign In
                                        </Button>
                                    </Grid>

                                </Grid>
                            </form>
                        </Grid>

                        <Grid item container xs={12} justifyContent='center'>
                            <Grid item container xs={10} md={5} lg={4} justifyContent='flex-end'>
                                <Grid item  className='forgot_password'>
                                    Forgot Password?
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }
}


function mapStateToProps(state) {

    return {

    }
};

export default connect(mapStateToProps, { Login, loginValidation })
    (reduxForm({
        form: 'EHubManagmentLogin',
        validate,
        enableReinitialize: true,
    })(EhubManagmentLogin));
